let isOffline = navigator.onLine ? false : true;
const statusListeners = [];

// internal methods
const setIsOffline = (offline) => {
  return isOffline = offline;
};

const notifyListeners = () => {
  const online = isOnline();
  statusListeners.forEach(fn => {
    if ( typeof fn === "function" ) {
      fn(online);
    }
  });
};

const bindListeners = () => {
  window.addEventListener('online',  () => {
    setIsOffline(false);
    notifyListeners();
  });

  window.addEventListener('offline', () => {
    setIsOffline(true);
    notifyListeners();
  });
};

// exported methods
export const isOnline = () => {
  return !isOffline;
};

export const registerStatusListener = (fn) => {
  statusListeners.push(fn);

  // the first time we get a status listener - bind the global status listeners
  if ( statusListeners.length === 1 ) {
    bindListeners();
  }

  // run the status listener now
  fn(isOnline());

  return statusListeners.indexOf(fn);
};



// WEBPACK FOOTER //
// ./src/module/Offline.js